<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>

    <scan v-model="item" />
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

import Scan from "./Scan.vue";

export default {
  components: {
    Scan,
  },

  data: () => ({
    cardLink: "transfer_containers",
    cardSetLink: "transfer_containers",
    item: null,

    fields: [
      {
        col: "col-12 col-md-6",
        label: "Вес (кг)",
        key: "weight",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Ширина (см)",
        key: "width",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Высота (см)",
        key: "height",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Длинна (см)",
        key: "length",
        type: "field",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item) {
        this.item = item;
      }
    },
  },
};
</script>

